module.exports = __webpack_public_path__ + "img/ad-wecom-popup-bg.449bee1a.png";